function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_950_2219)",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.269 9.597h3.75v-3.75",
  strokeWidth: "1.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.697 18.361a8.485 8.485 0 01-4.401 2.465 8.24 8.24 0 01-4.969-.51A8.695 8.695 0 014.468 17 9.303 9.303 0 013.018 12c0-1.78.505-3.52 1.45-5a8.695 8.695 0 013.86-3.316 8.24 8.24 0 014.968-.51 8.485 8.485 0 014.401 2.465l3.322 3.467",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.714 10.5l1.5-.75v4.5M13 9.75c-1.16 0-1.286 1.5-1.286 2.357 0 .847.19 2.143 1.286 2.143s1.286-1.357 1.286-2.143c0-.786-.125-2.357-1.286-2.357z",
  strokeWidth: "1.5"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_950_2219"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));